import styled from 'styled-components'
import { media } from '../../../../../layouts/utils'

export const Container = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	padding: 24px 36px;
	border-radius: 7.6px;
	box-shadow: 0px 0px 19px -3px #0D0D0D17;

	@media(max-width: 920px) {
		flex-direction: column;
		padding: 18px;
		gap: 36px;
	}
`

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`

export const Buttons = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;

	@media(max-width: 920px) {
		justify-content: flex-start;
	}
`

export const Terms = styled.div`
	display: flex;
	gap: 16px;
	color: #393939;
	font-size: 1rem;

	b {
		text-decoration: underline;
		user-select: none;
		cursor: pointer;
		transition: all 0.3s ease-in-out;
		&:hover {
			filter: brightness(1.2);
		}
	}

	label {
		font-family: "Work Sans";
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: normal;

		b {
			font-weight: 600;
			text-decoration-line: underline;
		}
	}

	${media.phone`
		font-size: 0.875rem;
		align-items: center;

		.container.calibri {
			width: 30px;
		}
 	`}
`
export const Link = styled.a`
	text-decoration: none;
	${({ disabled }) => disabled && `cursor: not-allowed; pointer-events: none;`}
`
export const ModalHeader = styled.div`
	display: flex;
	align-content: center;
	justify-content: flex-end;
	width: 100%;
	height: 40px;
`
export const CloseButton = styled.img`
	width: 1.5rem;
	height: 1.5rem;
	cursor: pointer;
	transition: all 0.3s ease-in-out;
	&:hover {
		filter: brightness(2);
	}
`
export const Line = styled.p`
	margin-bottom: 0.75rem;
	font-weight: 400;

	.bold {
		font-weight: bold;
	}
	.italic {
		font-style: italic;
	}
	.underline {
		text-decoration: underline;
	}
	.strike {
		text-decoration: line-through;
	}
`
export const TextBlock = styled.span`
	&.underline {
		text-decoration: underline;
	}
	&.bold {
		font-weight: bold;
	}
	&.italic {
		font-style: italic;
	}
`

export const Observation = styled.span`
	font-family: "Work Sans";
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 20px;
`
